export default __webpack_public_path__ + "static/media/efectos_objetos_construcciones.0898a9fa.png";